import {
    Box,
    Container,
    Paper,
    Stack,
    Step,
    StepLabel,
    Stepper,
} from "@mui/material";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrivilegeAlert, Spinner } from "../../../../components/exports";
import { UserAccessTypes } from "../../../../components/shared/PrivilegeAlert";
import { RootState } from "../../../../slices/Store";
import { useFetchGatewaNumbersQuery } from "../../api-hooks/smsCampaignQuery";
import SmsCampaignDetail from "../../components/SmsCampaignDetail";
import SmsCampaignExcelDestination from "../../components/SmsCampaignExcelDestination";
import SmsCampaignProjectDestination from "../../components/SmsCampaignProjectDestination";
import SmsCampaignSelectType from "../../components/SmsCampaignSelectType";
import SmsCampaignSettings from "../../components/SmsCampaignSettings";
import SmsCampaignTemplate from "../../components/SmsCampaignTemplate";
import {
    SmsCampaignType,
    setSmsCampaignGatewayNumbers,
} from "../../smsCampaignSlice/SmsCampaignSlice";

// list of steps according to destination
const steps = [
    {
        title: "انتخاب متن",
        availableDestinations: [
            SmsCampaignType.CampaignWithProjectFilter,
            SmsCampaignType.CampaignWithExcelFile,
            SmsCampaignType.CampaignWithTestMobileNumbers,
        ],
        component: <SmsCampaignTemplate />,
    },
    {
        title: "فیلتر پروژه ها",
        availableDestinations: [SmsCampaignType.CampaignWithProjectFilter],
        component: <SmsCampaignProjectDestination />,
    },
    {
        title: "فایل اکسل",
        availableDestinations: [SmsCampaignType.CampaignWithExcelFile],
        component: <SmsCampaignExcelDestination />,
    },
    {
        title: "تنظیمات کمپین",
        availableDestinations: [
            SmsCampaignType.CampaignWithProjectFilter,
            SmsCampaignType.CampaignWithExcelFile,
            SmsCampaignType.CampaignWithTestMobileNumbers,
        ],
        component: <SmsCampaignSettings />,
    },
    {
        title: "نهایی سازی",
        availableDestinations: [
            SmsCampaignType.CampaignWithProjectFilter,
            SmsCampaignType.CampaignWithExcelFile,
            SmsCampaignType.CampaignWithTestMobileNumbers,
        ],
        component: <SmsCampaignDetail />,
    },
];

export default function CreateSmsCampaign() {
    const smsCampaign = useSelector((state: RootState) => state.smsCampaign);
    const dispatch = useDispatch();

    const availableStepsForDestination = steps.filter((s) =>
        s.availableDestinations.includes(smsCampaign.smsCampaignType)
    );

    useEffect(() => {
        // if (smsCampaign.currentStep === 0) dispatch(setInitialState());
    }, [smsCampaign.currentStep]);

    const { data, isLoading } = useFetchGatewaNumbersQuery();

    useMemo(() => {
        if (data) {
            dispatch(setSmsCampaignGatewayNumbers(data));
        }
    }, [data]);

    if (isLoading) {
        return <Spinner />;
    }

    return (
        <Container maxWidth="sm">
            <PrivilegeAlert access={UserAccessTypes.ManageSmsCampaigns} />
            {availableStepsForDestination.length === 0 && (
                <SmsCampaignSelectType />
            )}
            {availableStepsForDestination.length > 0 && (
                <Stack spacing={2} sx={{ p: 2 }}>
                    <Stepper
                        activeStep={smsCampaign.currentStep}
                        alternativeLabel
                    >
                        {availableStepsForDestination.map((s) => {
                            return (
                                <Step key={s.title}>
                                    <StepLabel>{s.title}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>

                    <Paper sx={{ p: 2 }}>
                        {
                            availableStepsForDestination[
                                smsCampaign.currentStep
                            ].component
                        }
                    </Paper>
                </Stack>
            )}

            <Box sx={{ my: 2 }}>
                {/* <Alert severity="error">
                    همراهان عزیز پرشین سازه با توجه به شرایط این روزهای کشور،
                    متاسفانه سرویس پیامکی تبلیغاتی درحال حاضر دردسترس نبوده و
                    امکان درج لینک در سرویس پیامکی خدماتی نیز میسر نیست. به محض
                    برقراری مجدد از سوی نهادهای مرتبط، این خدمات دوباره در
                    اختیار شما عزیزان قرار می‌گیرند.
                </Alert> */}
            </Box>
        </Container>
    );
}
